import { render, staticRenderFns } from "./ChooseAddress.vue?vue&type=template&id=66ac432c&scoped=true&"
import script from "./ChooseAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseAddress.vue?vue&type=script&lang=js&"
import style1 from "./ChooseAddress.vue?vue&type=style&index=1&id=66ac432c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac432c",
  null
  
)

export default component.exports